///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CustomEventName } from '../../services/event-manager.service';

export class ProjectWindowsEvents {
    static readonly CLOSE_MODAL_WINDOW: CustomEventName = 'closeModalWindow';
}
